module.exports = __webpack_public_path__ + "./assets/img/brand2.a302d061.svg";